import React, { useState } from 'react';
import axios from 'axios';

// Fiscal: prévia (só visualização) do relatório diário de obrigações. O envio não
// existe na tela — sai só pelo comando agendado no servidor.

const API = process.env.REACT_APP_API_BASE;
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('access')}` });
const ROTULOS = {
  avisos: 'Faltam 2 dias', alertas: 'Hoje ou amanhã', vencidas: 'Vencidas', tarefas: 'Tarefas (até 3 dias)', retroativas: 'Notas retroativas',
};

export default function FiscalRelatorioPrevia() {
  const [aberto, setAberto] = useState(false);
  const [previa, setPrevia] = useState(null);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState('');

  const abrir = () => {
    setAberto(true); setPrevia(null); setErro(''); setCarregando(true);
    axios.get(`${API}/api/fiscal/relatorio/previa/`, { params: { _: Date.now() }, headers: headers() })
      .then((r) => setPrevia(r.data.previa))
      .catch((e) => setErro(e.response?.data?.mensagem || 'Não foi possível montar a prévia'))
      .finally(() => setCarregando(false));
  };

  return (
    <>
      <button type="button" className="gr-btn" onClick={abrir} title="Como fica hoje o e-mail diário enviado ao fiscal@">
        <i className="fas fa-envelope-open-text" aria-hidden="true"></i>Prévia do relatório diário
      </button>
      {aberto && (
        <div className="modal show d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,.45)' }}>
          <div className="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable">
            <div className="modal-content shadow-lg">
              <div className="modal-header" style={{ backgroundColor: '#ffffff', borderBottom: '1px solid #e9ecef' }}>
                <div>
                  <h5 className="modal-title mb-0 fw-bold" style={{ color: '#212529' }}><i className="fas fa-envelope-open-text me-2" style={{ color: '#00b5cc' }}></i>Prévia do relatório diário</h5>
                  <small style={{ color: '#6c757d' }}>Somente visualização — o envio é automático, pelo servidor.</small>
                </div>
                <button type="button" className="btn-close" onClick={() => setAberto(false)}></button>
              </div>
              <div className="modal-body">
                {carregando && <div className="text-center py-4 text-muted"><i className="fas fa-spinner fa-spin me-2"></i>Montando a prévia...</div>}
                {erro && <div className="alert alert-danger py-2">{erro}</div>}
                {previa && (
                  <>
                    <dl className="fz-conferencia row mx-0 mb-3">
                      <dt className="col-sm-2">Assunto</dt><dd className="col-sm-10">{previa.assunto}</dd>
                      <dt className="col-sm-2">De</dt><dd className="col-sm-10">{previa.de}</dd>
                      <dt className="col-sm-2">Para</dt><dd className="col-sm-10">{previa.para.join(', ')}</dd>
                      <dt className="col-sm-2">Cc</dt><dd className="col-sm-10">{previa.cc.length ? previa.cc.join(', ') : '—'}</dd>
                      <dt className="col-sm-2">Tamanho</dt>
                      <dd className="col-sm-10 fz-num">{previa.enviaria ? `${(previa.tamanho_bytes / 1024).toFixed(1)} KB` : '—'}</dd>
                    </dl>
                    <div className="d-flex flex-wrap gap-2 mb-3">
                      {Object.entries(previa.contagens).map(([k, n]) => (
                        <span key={k} className={`fz-selo ${n ? 'alerta' : 'neutro'}`}>{ROTULOS[k] || k}: <span className="fz-num">{n}</span></span>
                      ))}
                    </div>
                    {previa.enviaria ? (
                      <iframe title="Prévia do e-mail" sandbox="" srcDoc={previa.html} className="fz-previa-email"></iframe>
                    ) : (
                      <div className="alert alert-light border">Nada a relatar hoje: nenhum e-mail seria enviado.</div>
                    )}
                  </>
                )}
              </div>
              <div className="modal-footer bg-light">
                <button className="btn btn-secondary" onClick={() => setAberto(false)}><i className="fas fa-times me-2"></i>Fechar</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
